import Vue from 'vue';
import Router from 'vue-router';

import { router as appRouter } from '@/app';

import { CT_VIEWER_URL } from '@/config';
import beforeEachRoutes from './beforeEachRoutes';
import LandingMainV3 from '../components/LandingMainV3';
import InquiryForm from '../components/InquiryForm';

Vue.use(Router);

const router = new Router({
  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { y: 0 };
  },

  routes: [
    {
      path: '/',
      redirect: () => ('/library/custom-cards'),
      props: {
        attachHome: true,
      },
      meta: {
        requiresAuth: false,
        requiresTeacherRole: false,
      },
      // commented out for not skip landing
      // beforeEnter(to, from, next) {
      //   const skipLandingPage = Cookies.get('skip_landing_page_v2');

      //   if (isEmpty(skipLandingPage)) {
      //     return next();
      //   }

      //   if (JSON.parse(skipLandingPage) === false) {
      //     return next();
      //   }

      //   return next('/library');
      // },
    },
    {
      path: '/intro',
      component: LandingMainV3,
      props: {
        isIntro: true,
      },
      meta: {
        requiresAuth: false,
        requiresTeacherRole: false,
      },
    },
    {
      path: '/inquiries',
      component: InquiryForm,
      meta: {
        requiresAuth: false,
        requiresTeacherRole: false,
      },
    },
    {
      path: '/viewer/cards/:cardId(\\d+)',
      alias: '/viewer/assignments/:cardId(\\d+)',
      redirect: (to) => {
        const { params } = to;
        window.location.href = `${CT_VIEWER_URL}/viewer/cards/${params.cardId}`;
      },
      props: true,
    },
    {
      path: '/viewer/cats/:catId(\\d+)',
      redirect: (to) => {
        const { params } = to;
        window.location.href = `${CT_VIEWER_URL}/viewer/cats/${params.catId}`;
      },
      props: true,
    },
    {
      path: '/viewer/coin-cards/:cardId(\\d+)',
      redirect: (to) => {
        const { params } = to;
        window.location.href = `${CT_VIEWER_URL}/viewer/coin-cards/${params.cardId}`;
      },
      props: true,
    },
    ...appRouter,
  ],
});

beforeEachRoutes(router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js